"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicApiConfig = void 0;
const env_1 = require("../env/env");
const C2FO_API_GATEWAY = env_1.env.getString('GATEWAY_URL');
exports.publicApiConfig = {
    PUBLIC_API_URL: C2FO_API_GATEWAY ? `${C2FO_API_GATEWAY}/api/public/graphql` : 'http://localhost:9999/graphql',
};
//# sourceMappingURL=publicApiConfig.js.map